module.exports = __webpack_public_path__ + "static/wallpaper.d737c672.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallpaper.jpg
// module id = 441
// module chunks = 35783957827783